import _ from 'lodash';
import { ENUM_POINT_CHANGE_TYPE, OFFER_FIELDS } from '../utils/checkContents';
import {
  POINT_CHANGE_END_DATE,
  POINT_CHANGE_END_VALUE,
  POINT_CHANGE_START_DATE,
  POINT_CHANGE_START_VALUE,
} from '../../../content';
import { useAppSelector } from 'redux/hooks';
import * as Styled from './index.styles';
const checkMark = String.fromCodePoint(9989);
const xMark = String.fromCodePoint(10060);

// Define fields for Validation
const fieldsToValidate = [
  { key: 'label', label: 'Offer Label' },
  { key: 'offername', label: 'Offer Name' },
  { key: 'logourl', label: 'Image Url' },
  { key: 'backgroundimgurl', label: 'Background Image Url' },
  { key: 'fullscreenimageurl', label: 'Full Screen Image Url' },
  { key: 'headline', label: 'Subline' },
  { key: 'description', label: 'Body' },
  { key: 'ctatext', label: 'Call To Action' },
  { key: 'ctaurl', label: 'Clickthrough Url' },
  { key: 'category', label: 'Category' },
];

/**
 * Get validation fields for the current offer.
 * @param currentOffer - The current offer object.
 * @returns Array of validation fields for the current offer.
 */
function getValidationFields(currentOffer) {
  const validationFields = [...fieldsToValidate];

  if (currentOffer?.comparisonemoji) {
    validationFields.push({
      key: 'comparisontext',
      label: 'Comparison Text',
    });
  }

  if (currentOffer?.ispointschangescheduled) {
    validationFields.push({
      key: 'pointschangetype',
      label: 'Points Change Type',
    });

    if (currentOffer?.pointschangetype === ENUM_POINT_CHANGE_TYPE.PROMO) {
      validationFields.push(
        {
          key: OFFER_FIELDS.pointsChangeStartDate,
          label: POINT_CHANGE_START_DATE,
        },
        {
          key: OFFER_FIELDS.pointsChangeStartValue,
          label: POINT_CHANGE_START_VALUE,
        },
        {
          key: OFFER_FIELDS.pointsChangeEndDate,
          label: POINT_CHANGE_END_DATE,
        },
        {
          key: OFFER_FIELDS.pointsChangeEndValue,
          label: POINT_CHANGE_END_VALUE,
        }
      );
    } else if (
      currentOffer?.pointschangetype === ENUM_POINT_CHANGE_TYPE.ONETIME
    ) {
      validationFields.push(
        {
          key: OFFER_FIELDS.pointsChangeStartDate,
          label: POINT_CHANGE_START_DATE,
        },
        {
          key: OFFER_FIELDS.pointsChangeStartValue,
          label: POINT_CHANGE_START_VALUE,
        }
      );
    }
  }

  return validationFields;
}

const OfferPropertyComponent = ({ currentOffer, keyName, label }) => {
  let isValue = currentOffer && keyName && currentOffer[keyName];
  if (
    currentOffer &&
    keyName == 'category' &&
    Array.isArray(isValue) &&
    isValue.length === 0
  ) {
    isValue = false;
  }
  return (
    <Styled.RequiredRow>
      <Styled.RequiredRowEmoji>
        {isValue ? checkMark : xMark}
      </Styled.RequiredRowEmoji>
      <div>{label ? _.startCase(label) : null}</div>
    </Styled.RequiredRow>
  );
};

const SaveOfferDisabledButtonMessage = () => {
  const currentOffer = useAppSelector(
    (state) => state.offerWallReducer.currentOffer
  );
  const fieldsToValidate = getValidationFields(currentOffer);

  return (
    <Styled.MessageTextAlignment>
      <div>{"Hi! Looks like you're trying to save"}</div>
      <br />
      <div>To save make sure you have</div>
      <br />
      {currentOffer ? (
        <>
          {fieldsToValidate?.map((field) => {
            return (
              <OfferPropertyComponent
                key={`save-button-${field.key}-${field.label}`}
                currentOffer={currentOffer}
                keyName={field.key}
                label={field.label}
              />
            );
          })}
        </>
      ) : null}
    </Styled.MessageTextAlignment>
  );
};

/**
 * Component to display validation properties of the current offer.
 * @returns JSX element representing the offer properties for validation.
 */
export const OfferAllProperties = () => {
  const currentOffer = useAppSelector(
    (state) => state.offerWallReducer.currentOffer
  );

  // Get validation fields for the current offer placement
  const fieldsToValidate = getValidationFields(currentOffer);

  return (
    <Styled.MessageTextAlignment>
      {fieldsToValidate?.map((field) => {
        return (
          <OfferPropertyComponent
            key={`offer-${field.key}-${field.label}`}
            currentOffer={currentOffer}
            keyName={field.key}
            label={field.label}
          />
        );
      })}
    </Styled.MessageTextAlignment>
  );
};

export default SaveOfferDisabledButtonMessage;
